package app.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class ProjectRelease(
    val id: Int,
    val projectId: Int,
    val createdAt: Instant,
    val version: Version,
    val deployables: Map<String, String>
)
